/**
 * @fileoverview Shared helpers for unwrapping API response envelopes.
 * @module shared/lib/api-envelope
 */

export type ApiDataEnvelope<TData> = {
    success: true
    data: TData
}

/**
 * Unwraps API responses that may be wrapped in `{ success, data }`.
 */
export function unwrapApiData<TData>(payload: ApiDataEnvelope<TData> | TData): TData {
    return (payload as ApiDataEnvelope<TData>).data ?? (payload as TData)
}
